import { useMemo } from 'react';
import { useGlobalStore } from '@core/hooks/useGlobalStore';
import { productsHydratedSelector } from '@core/shopping/model';
import { mergeProductsWithHydrated } from '@core/shopping/utils/mergeProductsWithHydrated';
import { useStore } from '@embed/components/VideoPlayer/Player3/store';
import { hookOnlyLiveStreamProductsSelector } from '@embed/components/VideoPlayer/Player3/store/selectors';
/**
 * @returns Merged products list from the live stream and hydrated products.
 */
export const useLiveStreamProducts = () => {
    const video = useStore((state) => state.video);
    const originalLiveStreamProducts = useStore((state) => hookOnlyLiveStreamProductsSelector(state, video?.live_stream_id));
    const productsHydrated = useGlobalStore(productsHydratedSelector);
    return useMemo(() => mergeProductsWithHydrated(originalLiveStreamProducts ?? [], productsHydrated), [originalLiveStreamProducts, productsHydrated]);
};
